<script lang="ts" setup>
import { onMounted, ref } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { ZoneService } from '~/services/zone.service';

const visible = ref(false);
const zoneService = useService(ZoneService);

const handleSelectZone = (zone: string) => {
  zoneService.zone = zone;
  window.hetaoTrack('zoneselect_confirm_click', { zone });
};

const handleConfirmZone = () => {
  zoneService.updateZoneFromModal();
};

onMounted(() => {
  const needShow = zoneService.needShowZoneModal();
  if (needShow) {
    visible.value = true;
  }
});
</script>

<template>
  <a-modal
    v-model:open="visible"
    width="642px"
    centered
    :footer="null"
    :closable="false"
    :mask-closable="false"
    :destroy-on-close="true"
  >
    <div
      v-track:zoneselect_show
      class="px-[46px] pb-[16px] pt-[20px] text-center"
    >
      <h3 class="text-[28px] font-bold leading-[40px] text-[#000]">
        选手你好，欢迎来到核桃OJ
      </h3>
      <div class="mb-8 mt-3 text-base leading-[22px] text-subtitle">
        请选择你擅长编程语言或近期备战的赛事
      </div>
      <div class="flex flex-row items-center justify-between gap-6">
        <div
          class="card-zone flex h-[168px] w-1/2 cursor-pointer flex-col justify-center rounded-xl border-2"
          :class="{ active: zoneService.isCpp() }"
          @click="handleSelectZone('cpp')"
        >
          <div class="flex flex-row items-center justify-center">
            <img
              src="~/assets/image/icon/icon-cpp.svg"
              alt="C++"
              class="h-[60px] w-[60px]"
            />
            <div class="ml-3 text-2xl text-title">C++</div>
          </div>
          <div class="mt-4 text-tip">备战CSP、NOIP、NOI等赛事</div>
        </div>
        <div
          class="card-zone flex h-[168px] w-1/2 cursor-pointer flex-col justify-center rounded-xl border-2"
          :class="{ active: zoneService.isPython() }"
          @click="handleSelectZone('python')"
        >
          <div class="flex flex-row items-center justify-center">
            <img
              src="~/assets/image/icon/icon-python.svg"
              alt="C++"
              class="h-[60px] w-[60px]"
            />
            <div class="ml-3 text-2xl text-title">Python</div>
          </div>
          <div class="mt-4 text-tip">备战蓝桥杯、YCL、NOC等赛事</div>
        </div>
      </div>
      <a-button
        type="primary"
        block
        class="mb-3 mt-9 !h-[52px] !text-base !font-bold"
        @click="handleConfirmZone"
        >确认选择</a-button
      >
      <div class="h-[20px] leading-[20px] text-tip">选择后可随时切换</div>
    </div>
  </a-modal>
</template>

<style scoped>
.card-zone {
  border-color: #e5e5e5;
  transition: all 0.15s;
}
.card-zone:hover {
  border-color: #ccc;
}
.card-zone.active {
  @apply border-primary
}
</style>
